const TRUSTED_DEVICE_KEY = 'yyz-cbp-trusted-device-id'

function createDeviceId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }

  const bytes = new Uint8Array(16)
  if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
    crypto.getRandomValues(bytes)
  } else {
    for (let i = 0; i < bytes.length; i += 1) {
      bytes[i] = Math.floor(Math.random() * 256)
    }
  }

  return Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('')
}

export const trustedDevice = {
  getId(): string {
    let deviceId = localStorage.getItem(TRUSTED_DEVICE_KEY)
    if (!deviceId) {
      deviceId = createDeviceId()
      localStorage.setItem(TRUSTED_DEVICE_KEY, deviceId)
    }
    return deviceId
  }
}
